"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(document).on("click", "#btnStateAtLocation", function () {
    var productId = +(0, _jquery2.default)("#ProductId").val();
    var customerIds = (0, _jquery2.default)("#ddlOzUsers").val().split("|")[1]; // get comma-separated list of customerIds
    if (customerIds) {
        // IN operator is implemented in OData 4.01 and requires ODataLib >= 7.8.1 - thus we cannot use it
        // https://docs.microsoft.com/en-us/odata/changelog/odatalib-7x#odatalib-70-release
        // I've tried to update the libraries but it turned into a nightmare :'(
        // for this reason we're kind of simulate behavior of IN operator instead of using it
        var filterString = customerIds.split(",").reduce(function (prev, curr) {
            return prev ? prev + " or (customerId eq " + curr + ")" : "(customerId eq " + curr + ")";
        }, null);
        (0, _jquery2.default)("#stateAtLocation").DataTable().query(function (x) {
            x.id = productId, x.$filter = filterString;
        }); // `customerId in (${customerIds})` });
        (0, _jquery2.default)("#stateAtLocation").DataTable().ajax.reload(null, false);
        (0, _jquery2.default)(".state-at-location-table").show();
        return;
    }

    (0, _jquery2.default)(".state-at-location-table").hide();
});


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/stateAtLocationFilterByOzUser.js
// module id = 964
// module chunks = 0